import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { MarkerDetailWrapper } from '../wrappers/marker_detail_wrapper';
import { MarkerDetailTitle } from './marker_detail/title';
import { MarkerDetailContent } from './marker_detail/content';
import { MarkerDetailLink } from './marker_detail/link';
import { Context } from '../../store/context';
import { styled } from '@mui/material';

const MarkerDetailContentItem = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  flexDirection: 'column',
  padding: '10px 0',
  borderBottom: '1px solid #e9edef',
  fontFamily: 'Roboto',
  fontSize: '14px',
  color: '#686868',
  fontWeight: 400,
}));
const MarkerDetailContentItemLabel = styled('div')(() => ({}));
const MarkerDetailContentItemValue = styled('div')(() => ({
  fontFamily: 'Montserrat',
  fontSize: '16px',
  fontWeight: 600,
}));
const MarkerDetailContentItemValuePhone = styled(MarkerDetailContentItemValue)(
  () => ({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '10px',
    p: {
      margin: 0,
    },
  })
);

function copytoClipBoard(text) {
  navigator.clipboard
    .writeText(text)
    .then(() => alert('Contenido copiado: ' + text))
    .catch((err) => console.error('Error al copiar: ', err));
}

function MarkerDetail({
  id,
  title,
  direction,
  schedule,
  phone,
  lat,
  lng,
  number,
}) {
  const { activeMarkerId, setActivemarkerid } = useContext(Context);

  return (
    <>
      <MarkerDetailWrapper onClick={() => setActivemarkerid(id)}>
        <MarkerDetailTitle active={id === activeMarkerId}>
          {title}
        </MarkerDetailTitle>
        <MarkerDetailContent>
          <MarkerDetailContentItem>
            <MarkerDetailContentItemLabel>
              Dirección:
            </MarkerDetailContentItemLabel>
            <MarkerDetailContentItemValue
              onClick={() => copytoClipBoard(direction)}
            >
              {direction}{' '}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#e3e3e3"
              >
                <path d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z" />
              </svg>
            </MarkerDetailContentItemValue>
          </MarkerDetailContentItem>
          <MarkerDetailContentItem>
            <MarkerDetailContentItemLabel>
              Horario de atención:
            </MarkerDetailContentItemLabel>
            <MarkerDetailContentItemValue>
              {schedule}
            </MarkerDetailContentItemValue>
          </MarkerDetailContentItem>
          <MarkerDetailContentItem>
            <MarkerDetailContentItemLabel>
              Teléfono:
            </MarkerDetailContentItemLabel>
            <MarkerDetailContentItemValuePhone
              onClick={() => copytoClipBoard(phone)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
              >
                <g
                  id="Grupo_6466"
                  data-name="Grupo 6466"
                  transform="translate(-526 -557)"
                >
                  <circle
                    id="Elipse_11"
                    data-name="Elipse 11"
                    cx="8"
                    cy="8"
                    r="8"
                    transform="translate(526 557)"
                    fill="#1063ac"
                  />
                  <path
                    id="llamada"
                    d="M11.744,9.185h0l-1.378-.8a.915.915,0,0,0-1.248.334.611.611,0,0,1-.383.315.55.55,0,0,1-.464-.1A8.965,8.965,0,0,1,6.706,7.37a.55.55,0,0,1-.1-.464.611.611,0,0,1,.315-.383.915.915,0,0,0,.334-1.248L6.456,3.9A.908.908,0,0,0,5.331,3.5l-.016.006a4.771,4.771,0,0,0-1.339.656,2.115,2.115,0,0,0-.419,2.188,9.882,9.882,0,0,0,5.731,5.732,3.15,3.15,0,0,0,.815.116,1.871,1.871,0,0,0,1.373-.535,4.771,4.771,0,0,0,.656-1.339l.007-.017A.908.908,0,0,0,11.744,9.185Zm-.261.868-.007.017a6.637,6.637,0,0,1-.5,1.1,1.478,1.478,0,0,1-1.508.237A9.183,9.183,0,0,1,4.235,6.172a1.478,1.478,0,0,1,.237-1.508,6.627,6.627,0,0,1,1.1-.5l.017-.007a.216.216,0,0,1,.079-.015.207.207,0,0,1,.18.106l.8,1.378a.211.211,0,0,1-.077.288,1.3,1.3,0,0,0-.652.851,1.25,1.25,0,0,0,.231,1.027A9.613,9.613,0,0,0,7.849,9.5a1.25,1.25,0,0,0,1.027.231,1.3,1.3,0,0,0,.851-.652A.212.212,0,0,1,10.014,9l1.378.8a.207.207,0,0,1,.091.259Z"
                    transform="translate(526.179 557.18)"
                    fill="#fff"
                  />
                </g>
              </svg>
              <p>
                {phone}{' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                  fill="#e3e3e3"
                >
                  <path d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z" />
                </svg>
              </p>
            </MarkerDetailContentItemValuePhone>
          </MarkerDetailContentItem>
        </MarkerDetailContent>
        <MarkerDetailLink>
          <a
            href={`https://www.google.com/maps/dir//${lat},${lng}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            ¿Cómo llegar?
          </a>
        </MarkerDetailLink>
        <p
          style={{
            position: 'absolute',
            right: '10px',
            bottom: '0',
            color: '#CCC',
          }}
        >
          {number}
        </p>
      </MarkerDetailWrapper>
    </>
  );
}

MarkerDetail.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  direction: PropTypes.string,
  schedule: PropTypes.string,
  phone: PropTypes.string,
  lat: PropTypes.number,
  lng: PropTypes.number,
  active: PropTypes.bool,
  setActive: PropTypes.func,
  number: PropTypes.number,
};

export default MarkerDetail;
